import { gql } from '@zenbusiness/application-commons-graphql';

export const DEPOSIT_MUTATION = gql`
  mutation deposit($input: CreateBankingPaymentInput!) {
    createBankingPayment(input: $input) {
      reason
      transactionId
    }
  }
`;

export const TRANSFER_MUTATION = gql`
  mutation transfer($input: CreateBankingPaymentInput!) {
    createBankingPayment(input: $input) {
      id
      type
      status
      reason
      direction
      summary
      amount {
        amount
        currency
      }
      createdAt
      fromAccount
      toAccount
    }
  }
`;

export const WITHDRAW_MUTATION = gql`
  mutation withdraw($input: CreateBankingPaymentInput!) {
    createBankingPayment(input: $input) {
      id
      type
      status
      reason
      direction
      summary
      amount {
        amount
        currency
      }
      createdAt
      fromAccount
      toAccount
    }
  }
`;

export const WIRE_MUTATION = gql`
  mutation wire($input: CreateBankingPaymentInput!) {
    createBankingPayment(input: $input) {
      id
      type
      status
      reason
      direction
      summary
      amount {
        amount
        currency
      }
      createdAt
      fromAccount
      toAccount
      description
    }
  }
`;
